import { render, staticRenderFns } from "./SCameraCapture.vue?vue&type=template&id=c4eca96a"
import script from "./SCameraCapture.vue?vue&type=script&lang=js"
export * from "./SCameraCapture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports